import initialState from "../store/initial-state";
import {
  APP_RESIZE,
  KEY_COLLECTION,
  APP_KEYBOARD_ENABLED,
  ADVANCED_SEARCH_ENABLED,
  ADVANCED_SEARCH_VALUES_FROM_NAVBAR,
  ASSET_TYPE,
  ADVANCED_SEARCH_VISIBLE,
  EDIT_MY_ACCOUNT_VISIBLE,
  SELECTED_CP_ACTIVITY_LOG_VALUE,
  SELECTED_FOLDER_EXPLORE
} from "../constants/app-types";

export default (state = initialState.app, action) => {
  switch (action.type) {
    case APP_RESIZE:
      let vertical = 5;
      let horizontal = 4;
      let width = action.payload;
      if (width > 768) {
        vertical = 5;
        horizontal = 4.2;
      } else if (width > 425 && width <= 768) {
        vertical = 3;
        horizontal = 2.5;
      } else {
        vertical = 1;
        horizontal = 1;
      }
      return {
        ...state,
        width,
        verticalCount: vertical,
        horizontalCount: horizontal
      };

    case KEY_COLLECTION:
      return {
        ...state,
        keyCollection: action.payload
      };

    case APP_KEYBOARD_ENABLED:
      return {
        ...state,
        keyboardEnable: action.payload
      };
    case ADVANCED_SEARCH_ENABLED:
      return {
        ...state,
        advancedSearchEnable: action.payload
      };

    case ADVANCED_SEARCH_VALUES_FROM_NAVBAR:
      return {
        ...state,
        advancedSearchValuesFromNavbar: action.payload
      };
    case ASSET_TYPE:
      return {
        ...state,
        assetType: action.payload
      };
    case ADVANCED_SEARCH_VISIBLE:
      return {
        ...state,
        advancedSearchVisible: action.payload
      };
    case EDIT_MY_ACCOUNT_VISIBLE:
      return {
        ...state,
        editMyAccountVisible: action.payload
      };
    case SELECTED_CP_ACTIVITY_LOG_VALUE:
      return {
        ...state,
        cpActivityLogSelectedValue: action.payload
      };
    case SELECTED_FOLDER_EXPLORE:
      return {
        ...state,
        selectedFolderExplore: action.payload
      };
    default:
      return { ...state };
  }
};
